import { useContext, useMemo } from 'react';
import { ProductTableContext } from '../../../contexts/product-table-context';
import { preciseCurrencyFormatter } from '../../../helpers/format-currency';

export function TotalValue({ className }: { className?: string }) {
  const { filteredProducts } = useContext(ProductTableContext);
  const totalValue = useMemo(() => {
    const value = filteredProducts.reduce((total, product) => {
      return total + product.last_cost * product.inventory_qty;
    }, 0);

    return preciseCurrencyFormatter(value);
  }, [filteredProducts]);

  return (
    <div className={`flex flex-row items-center ${className || ''}`}>
      <div className="text-sm font-medium text-gray-700 min-w-20 shrink-0">Total Value</div>
      <div className="shrink-0 ml-2 flex-1">{totalValue}</div>
    </div>
  );
}
